// extracted by mini-css-extract-plugin
export default {"NotificationSettings__FormUpdateContainer":"NotificationSettings_NotificationSettings__FormUpdateContainer__khvy0"};